export const HTTP_STATUS_OK = 200;
export const HTTP_STATUS_PARTIAL_CONTENT = 206;
export const HTTP_STATUS_FORBIDDEN = 403;
export const HTTP_STATUS_NOT_FOUND = 404;
export const HTTP_STATUS_GONE = 410;
export const HTTP_STATUS_RANGE_NOT_SATISFIABLE = 416;
